const initialState = {
  index: [],
  selected: [],
  data: {},
};

const Documentation = (state = initialState, action) => {
  switch (action.type) {
    case "DOCUMENTATION_INDEX":
      return { ...state, index: action.payload.index };
    case "DOCUMENTATION_SELECTED":
      return { ...state, selected: action.payload.selected };
    case "DOCUMENTATION_DATA":
      return { ...state, data: action.payload.data };
    case "DOCUMENTATION_RESET":
      return initialState;
    default:
      return state;
  }
};

export default Documentation;
